var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.96 4.54a.65.65 0 0 1 0 .92L8.42 10l4.54 4.54a.65.65 0 1 1-.92.92l-5-5a.65.65 0 0 1 0-.92l5-5a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45NTk2IDQuNTQwMzhDMTMuMjEzNSA0Ljc5NDIyIDEzLjIxMzUgNS4yMDU3OCAxMi45NTk2IDUuNDU5NjJMOC40MTkyMyAxMEwxMi45NTk2IDE0LjU0MDRDMTMuMjEzNSAxNC43OTQyIDEzLjIxMzUgMTUuMjA1OCAxMi45NTk2IDE1LjQ1OTZDMTIuNzA1OCAxNS43MTM1IDEyLjI5NDIgMTUuNzEzNSAxMi4wNDA0IDE1LjQ1OTZMNy4wNDAzNyAxMC40NTk2QzYuNzg2NTMgMTAuMjA1OCA2Ljc4NjUzIDkuNzk0MjIgNy4wNDAzNyA5LjU0MDM4TDEyLjA0MDQgNC41NDAzOEMxMi4yOTQyIDQuMjg2NTQgMTIuNzA1OCA0LjI4NjU0IDEyLjk1OTYgNC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";